import { signHyperliquidL1Action } from './hlOrderSign';
import { pickActiveEvmWallet, connectEvmWallet } from './detectEvmWallets';
import { EVM_WALLET_SIGN_MSG, evmWalletMismatchMsg } from './evmWalletMessages';

export async function submitSingleAssetHlTrade({ walletAddress, orderId, prepared, apiBase, authHeaders }) {
  const w = await pickActiveEvmWallet();
  if (!w) throw new Error(EVM_WALLET_SIGN_MSG);

  const { address } = await connectEvmWallet(w.provider);
  if (walletAddress && address.toLowerCase() !== String(walletAddress).trim().toLowerCase()) {
    throw new Error(evmWalletMismatchMsg(address));
  }

  const signature = await signHyperliquidL1Action(w.provider, address, prepared.action, prepared.nonce);

  const axios = (await import('axios')).default;
  const { data } = await axios.post(
    `${apiBase}/single-asset-hl/trade/${orderId}/submit`,
    { action: prepared.action, nonce: prepared.nonce, signature },
    { headers: authHeaders() }
  );

  return data;
}
